import { Modal } from "react-bootstrap";
import { Comparison } from "../../types";
import { Button } from "../styles/Button.styled";
import { ComparePlanSummaryRow, PlanSummaryRow } from "../styles/Enrollment.styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";

// export interface ModalPlan {
//   value?: number;
//   unit: string;
//   color: string;
//   iconColor?: string;
//   logoSrc?: string;
//   plan_name?: string;
//   plan_id?: string;
//   terms_url?: string;
//   yrac?: string;
//   efl_url?: string;
// }

const ComparsionModal = ({
  selectComparisonCardModal,
  show,
  handleClose,
}: {
  selectComparisonCardModal: Comparison;
  show: boolean;
  handleClose: () => void;
}) => {

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header
        style={{
          color: "#2372B9",
          padding: "8px 12px",
          margin: 15,
          alignItems: "center",
        }}
        closeButton
      >
        <Modal.Title
          style={{
            color: "#2372B9",
            maxWidth: "70%",
            textAlign: "left",
            lineHeight: 1,
          }}
        >
          Best plans for you
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "1.5rem" }}>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="compare_modal">
           <div className="d-flex align-items-center mb-3">
             <div className="rep-logo me-3" style={{ flexShrink: 0 }}>
              <img
                src={selectComparisonCardModal.logoSrc}
                width="100%"
                style={{ maxWidth: 125 }}
                alt=""
              />
            </div>
            <div className="modal-plan-name">
            <span>  {selectComparisonCardModal.plan_name}</span>
            </div>
           </div>
            <ComparePlanSummaryRow>
              <label>
                Rate
                {/* (Based on 1,000 kWh) */}:
              </label>
              {selectComparisonCardModal.value && (
                <span>
                  {" "}
                 <b> {selectComparisonCardModal.value}¢</b>
                </span>
              )}
            </ComparePlanSummaryRow>
            <ComparePlanSummaryRow>
              <label>
              Plan Length
                {/* (Based on 1,000 kWh) */}:
              </label>
              {selectComparisonCardModal.contract_term && (
                <span>
                  {" "}
                  {selectComparisonCardModal.contract_term}{" "}Months
                </span>
              )}
            </ComparePlanSummaryRow>

            <div className="plan-links mt-3">
              {selectComparisonCardModal.yrac && (
                <PlanSummaryRow key={1} narrow>
                  <a
                    href={selectComparisonCardModal.yrac}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon="file-pdf" />
                    <span className="ms-2">YRAC</span>
                  </a>
                </PlanSummaryRow>
              )}

              {selectComparisonCardModal.terms_url && (
                <PlanSummaryRow key={2} narrow>
                  <a
                    href={selectComparisonCardModal.terms_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon="file-pdf" />
                    <span className="ms-2">TOS</span>
                  </a>
                </PlanSummaryRow>
              )}

              {selectComparisonCardModal.efl_url && (
                <PlanSummaryRow key={3} narrow>
                  <a
                    href={selectComparisonCardModal.efl_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon="file-pdf" />
                    <span className="ms-2">EFL</span>
                  </a>
                </PlanSummaryRow>
              )}
              <br/>
              
            </div>
              <span style={{color:"#999999",fontSize:"12px", paddingTop:"2px"}}>Please print or save these documents for your reference.</span>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ComparsionModal;
